import script from "./cardAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./cardAlert.vue?vue&type=script&setup=true&lang=js"

import "./cardAlert.vue?vue&type=style&index=0&id=0feef9e2&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0feef9e2"]])

export default __exports__